import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Confirm, Loading } from "@/components/common";
import { LabelBadge } from "@/components/badges";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export function CollectorAssign() {
  const { tenant } = useAuth();
  const [rows, setRows] = useState(null);
  const load = useCallback(async () => {
    try { setRows((await api.get("/collectors")).data); } catch (e) { toast.error(errMsg(e)); }
  }, []);
  useEffect(() => {
    load();
  }, [load]);
  const set = async (u, assigned) => {
    try {
      await api.put(`/collectors/${u.id}/assign`, { assigned });
      toast.success(assigned ? `${u.username} ditugaskan di ${tenant?.name || "perusahaan ini"}` : `Penugasan ${u.username} dicabut`);
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };
  if (!rows) return <Loading />;
  return (
    <div className="space-y-3" data-testid="collector-assign">
      <p className="text-xs text-slate-600">Petugas penarikan hanya bisa melihat pelanggan, invoice, nota, dan hutang di perusahaan tempat ia ditugaskan. Akun petugas dibuat oleh Admin Utama.</p>
      {rows.length === 0 && <div className="text-center text-slate-500 py-8 border border-dashed rounded-sm">Belum ada akun petugas penarikan</div>}
      <div className="grid gap-2 sm:grid-cols-2">
        {rows.map((u, i) => (
          <div key={u.id} className="border border-slate-300 bg-white rounded-sm p-3 flex items-center gap-3" data-testid={`collector-row-${i}`}>
            <div className="flex-1 min-w-0">
              <div className="font-medium truncate">{u.name || u.username} <span className="text-xs text-slate-500">@{u.username}</span></div>
              <div className="flex flex-wrap gap-1 mt-1">
                <LabelBadge text={u.assigned ? "DITUGASKAN DI SINI" : "TIDAK DITUGASKAN"} tone={u.assigned ? "green" : "slate"} testId={`collector-status-${i}`} />
                {!u.active && <LabelBadge text="AKUN NONAKTIF" tone="red" />}
              </div>
            </div>
            {u.assigned ? (
              <Confirm title={`Cabut penugasan ${u.username}?`} description="Petugas tidak bisa lagi mengakses perusahaan ini." onConfirm={() => set(u, false)} testId={`collector-unassign-${i}`}
                trigger={<Button variant="outline" className="h-11 sm:h-9 text-rose-700 border-rose-300" data-testid={`collector-unassign-btn-${i}`}>Cabut</Button>} />
            ) : (
              <Button onClick={() => set(u, true)} className="h-11 sm:h-9 bg-emerald-700 hover:bg-emerald-800" data-testid={`collector-assign-btn-${i}`}>Tugaskan</Button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
